<template lang="html">
  <div class="page-section text-content">
    <div class="container">
      <div v-for="(item, index) in items" :key="`item-${index}`" @click="highlightField('text')">
        <div
          :class="[
            'column',
            {'content-bg': parse(item).boxed},
            {'has-border': parse(item).column_borders}
          ]"
          :style="columnStyle(parse(item))"
          v-html="parse(item).text"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'TextContent',

  mixins: [parseComponent],

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    columnStyle() {
      return (item) => {
        return `column-count: ${item.columns};`
      }
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/base/theme'

.text-content
  .column
    column-gap: $gap-medium
    margin-bottom: $gap-medium
    column-rule: 1px solid rgba(0, 0, 0, 0)
    transition: all .2s ease-in-out

    &.has-border
      column-rule: 1px solid rgba(0, 0, 0, 0.2)
      column-gap: $gap-large

    &.content-bg
      background: #fff
      padding: $gap-small
      box-shadow: $content-shadow

    p
      margin-top: 0
</style>
